import React from "react";

// Decorative sunflower — stylised, flat, used as background accents.
export const Sunflower = ({
  size = 120,
  className = "",
  petalColor = "#F5B800",
  centerColor = "#6B3F1E",
  leafColor = "#7FA05A",
  showLeaves = false,
}) => {
  const petals = Array.from({ length: 16 });
  return (
    <svg
      viewBox="-120 -120 240 240"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      {showLeaves && (
        <g>
          <ellipse
            cx="-60"
            cy="70"
            rx="36"
            ry="14"
            fill={leafColor}
            transform="rotate(-35 -60 70)"
            opacity="0.85"
          />
          <ellipse
            cx="55"
            cy="72"
            rx="32"
            ry="12"
            fill={leafColor}
            transform="rotate(30 55 72)"
            opacity="0.85"
          />
        </g>
      )}
      <g>
        {petals.map((_, i) => (
          <ellipse
            key={i}
            cx="0"
            cy="-70"
            rx="18"
            ry="46"
            fill={petalColor}
            transform={`rotate(${(i * 360) / petals.length})`}
          />
        ))}
      </g>
      <circle cx="0" cy="0" r="40" fill={centerColor} />
      <circle cx="0" cy="0" r="32" fill="#4A2A10" opacity="0.35" />
      {/* seed pattern */}
      {Array.from({ length: 5 }).map((_, r) => (
        <g key={r}>
          {Array.from({ length: 10 + r * 2 }).map((__, i) => {
            const radius = 10 + r * 6;
            const angle = (i * 360) / (10 + r * 2) + r * 12;
            const x = Math.cos((angle * Math.PI) / 180) * radius;
            const y = Math.sin((angle * Math.PI) / 180) * radius;
            return (
              <circle
                key={`${r}-${i}`}
                cx={x}
                cy={y}
                r="1.6"
                fill="#F5B800"
                opacity="0.55"
              />
            );
          })}
        </g>
      ))}
    </svg>
  );
};

export const SunflowerMini = ({ size = 28, className = "" }) => (
  <svg
    viewBox="-50 -50 100 100"
    width={size}
    height={size}
    className={className}
    aria-hidden="true"
  >
    {Array.from({ length: 12 }).map((_, i) => (
      <ellipse
        key={i}
        cx="0"
        cy="-28"
        rx="7"
        ry="18"
        fill="#F5B800"
        transform={`rotate(${i * 30})`}
      />
    ))}
    <circle cx="0" cy="0" r="14" fill="#6B3F1E" />
  </svg>
);
